import { render, staticRenderFns } from "./displayDeviceMonitor.vue?vue&type=template&id=135fc5a1&scoped=true"
import script from "./displayDeviceMonitor.vue?vue&type=script&lang=js"
export * from "./displayDeviceMonitor.vue?vue&type=script&lang=js"
import style0 from "./displayDeviceMonitor.vue?vue&type=style&index=0&id=135fc5a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135fc5a1",
  null
  
)

export default component.exports